import { createContext, useContext } from "react";

interface ScribeCollapseContextType {
  isScribeCollapsed: boolean;
  toggleScribe: () => void;
  isScribeAvailable: boolean;
}

const ScribeCollapseContext = createContext<ScribeCollapseContextType>({
  isScribeCollapsed: false,
  toggleScribe: () => {},
  isScribeAvailable: false,
});

export const ScribeCollapseProvider = ScribeCollapseContext.Provider;

export function useScribeCollapse() {
  return useContext(ScribeCollapseContext);
}
